"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _state = require("@seedlang/state");
var _models = require("@seedlang/models");
var _serializr = require("serializr");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ReviewCreateWrapper = function ReviewCreateWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "showAddWord", _descriptor, _this);
      _initializerDefineProperty(_this, "word", _descriptor2, _this);
      _initializerDefineProperty(_this, "selectedDeckId", _descriptor3, _this);
      _initializerDefineProperty(_this, "cardTypeIds", _descriptor4, _this);
      _initializerDefineProperty(_this, "reviewCreatedMessage", _descriptor5, _this);
      _initializerDefineProperty(_this, "numberCards", _descriptor6, _this);
      _initializerDefineProperty(_this, "frontText", _descriptor7, _this);
      _initializerDefineProperty(_this, "backText", _descriptor8, _this);
      _initializerDefineProperty(_this, "wordSearchValue", _descriptor9, _this);
      _initializerDefineProperty(_this, "wordSearchFocused", _descriptor10, _this);
      _initializerDefineProperty(_this, "showSpinner", _descriptor11, _this);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "disableSubmit",
      get: function get() {
        return (0, _utils.isPresent)(this.word) && (0, _utils.isBlank)(this.cardTypeIds) || (0, _utils.isBlank)(this.word) && !((0, _utils.isPresent)(this.frontText) && (0, _utils.isPresent)(this.backText));
      }
    }, {
      key: "disableCancel",
      get: function get() {
        return (0, _utils.isBlank)(this.word) && (0, _utils.isBlank)(this.frontText) && (0, _utils.isBlank)(this.backText);
      }
    }, {
      key: "cardTypeOptions",
      get: function get() {
        var options = [['b6813ff6-c5df-4dd5-b9bc-202be20bfa8c', 'Word Translation'], ['a677c94d-8345-46bd-a837-efea27bafd95', 'Word Comprehension'], ['ea744c6b-add2-4414-8755-0a7a9e90e3ad', 'Word Multiple Choice']];
        if (this.word && this.word.isNoun && !this.word.hideFromGenderTrainer) {
          options.push(['bf2b0984-ddf0-4e88-ae95-4fb5a309370c', 'Gender']);
        }
        if (this.word && this.word.isNoun && !this.word.hideFromPluralTrainer && !this.word.noPlural && this.word.languageId === 'DE') {
          options.push(['19a422d1-1622-440b-b4d0-03205bfd29c8', 'Plural']);
        }
        if (this.word && this.word.isVerb && !this.word.hideFromConjugationTrainer) {
          options.push(['42593191-a5f0-40ce-a584-7c653dd08c97', 'Conjugation']);
        }
        return options;
      }
    }, {
      key: "userSubmission",
      get: function get() {
        return (0, _utils.isBlank)(this.word);
      }
    }, {
      key: "showAddGermanWordTab",
      get: function get() {
        return this.showAddWord && (0, _utils.isBlank)(this.frontText);
      }
    }, {
      key: "defaultDeckId",
      get: function get() {
        var _AppUI$filteredReview;
        return (_AppUI$filteredReview = _state.AppUI.filteredReviewDecks) === null || _AppUI$filteredReview === void 0 || (_AppUI$filteredReview = _AppUI$filteredReview.filter(function (item) {
          return item.languageId === _state.AppUI.targetLanguageId;
        })[0]) === null || _AppUI$filteredReview === void 0 ? void 0 : _AppUI$filteredReview.id;
      }
    }, {
      key: "deckId",
      get: function get() {
        if ((0, _utils.isPresent)(this.selectedDeckId)) {
          return this.selectedDeckId;
        } else if ((0, _utils.isPresent)(_state.AppUI.reviewDeckOptions)) {
          return _state.AppUI.reviewDeckOptions[0][0];
        }
      }
    }, {
      key: "toggleConvertCardSubmissions",
      value: function toggleConvertCardSubmissions() {
        var newValue = !_state.AppUI.user['convertCardSubmissions'];
        _state.AppUI.user.set('convertCardSubmissions', newValue);
        _state.AppUI.authUserStore.update({
          data: {
            convert_card_submissions: newValue
          }
        }, _lodash.noop);
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        _state.AppUI.createEvent('reviews - view create reviews');
      }
    }, {
      key: "onSubmit",
      value: function onSubmit() {
        if (!this.disableSubmit) {
          this.showSpinner = true;
          var data = {
            interface_source: 'review-create',
            deckId: this.deckId,
            languageId: _state.AppUI.targetLanguageId,
            userId: _state.DeckUI.user.id,
            userSubmission: this.userSubmission,
            frontText: (0, _utils.isBlank)(this.word) && this.frontText,
            backText: (0, _utils.isBlank)(this.word) && this.backText,
            wordId: (0, _utils.isPresent)(this.word) && this.word.id,
            cardTypeIds: this.userSubmission ? ['88631b6e-0a8c-400a-9be0-5b84878f652e'] : this.cardTypeIds
          };
          _state.AppUI.set('reloadReviewDecks', true);
          _state.DeckUI.cardStore.create({
            data: data
          }, this.afterSubmit);
        }
      }
    }, {
      key: "afterSubmit",
      value: function afterSubmit() {
        if (_state.AppUI.user.reviewCardsCount === 0) {
          _state.AppUI.loadUser();
        }
        this.showSpinner = false;
        _state.AppUI.user.set('reviewCardsCount', _state.AppUI.user.reviewCardsCount + 1);
        if (this.userSubmission || this.cardTypeIds.length === 1) {
          this.reviewCreatedMessage = 'This card was successfully created.';
        } else {
          this.reviewCreatedMessage = 'These cards were successfully created.';
        }
        this.onCancel();
        setTimeout(this.removeReviewCreatedMessage, 5000);
      }
    }, {
      key: "removeReviewCreatedMessage",
      value: function removeReviewCreatedMessage() {
        this.reviewCreatedMessage = null;
      }
    }, {
      key: "onSetShowAddWord",
      value: function onSetShowAddWord(showAddWord) {
        this.showAddWord = showAddWord;
        this.word = null;
      }
    }, {
      key: "onSetFrontText",
      value: function onSetFrontText(frontText) {
        this.frontText = frontText;
      }
    }, {
      key: "onSetBackText",
      value: function onSetBackText(backText) {
        this.backText = backText;
      }
    }, {
      key: "onSetDeckId",
      value: function onSetDeckId(deckId) {
        this.selectedDeckId = deckId;
      }
    }, {
      key: "onSetWord",
      value: function onSetWord(word) {
        if (word && word.attributes) {
          this.word = (0, _serializr.deserialize)(_models.Word, word.attributes);
        } else {
          this.word = word;
        }
        if (!word) {
          this.onCancel();
        }
      }
    }, {
      key: "onSetCardTypeId",
      value: function onSetCardTypeId(cardTypeId) {
        if (this.cardTypeIds.includes(cardTypeId)) {
          this.cardTypeIds = this.cardTypeIds.filter(function (id) {
            return id !== cardTypeId;
          });
        } else {
          this.cardTypeIds.push(cardTypeId);
        }
      }
    }, {
      key: "onCreateWord",
      value: function onCreateWord() {
        this.frontText = this.wordSearchValue;
      }
    }, {
      key: "onCancel",
      value: function onCancel() {
        this.frontText = '';
        this.backText = '';
        this.word = null;
        this.cardTypeIds = ['b6813ff6-c5df-4dd5-b9bc-202be20bfa8c'];
        this.deckIds = [];
        this.wordSearchValue = null;
      }
    }, {
      key: "onSetWordSearchValue",
      value: function onSetWordSearchValue(val) {
        this.wordSearchValue = val;
      }
    }, {
      key: "onBlurWordSearch",
      value: function onBlurWordSearch() {
        this.wordSearchFocused = false;
      }
    }, {
      key: "onFocusWordSearch",
      value: function onFocusWordSearch() {
        this.wordSearchFocused = true;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          reviewDeckOptions: _state.AppUI.reviewDeckOptions,
          word: this.word,
          showAddWord: this.showAddWord,
          reviewCreatedMessage: this.reviewCreatedMessage,
          numberCards: this.numberCards,
          frontText: this.frontText,
          backText: this.backText,
          deckId: this.deckId,
          disableSubmit: this.disableSubmit,
          onSubmit: this.onSubmit,
          afterSubmit: this.afterSubmit,
          removeReviewCreatedMessage: this.removeReviewCreatedMessage,
          onSetDeckId: this.onSetDeckId,
          onSetShowAddWord: this.onSetShowAddWord,
          onSetFrontText: this.onSetFrontText,
          onSetBackText: this.onSetBackText,
          onSetWord: this.onSetWord,
          cardTypeOptions: this.cardTypeOptions,
          cardTypeId: this.cardTypeId,
          onSetCardTypeId: this.onSetCardTypeId,
          onCreateWord: this.onCreateWord,
          onCancel: this.onCancel,
          disableCancel: this.disableCancel,
          onSetWordSearchValue: this.onSetWordSearchValue,
          wordSearchValue: this.wordSearchValue,
          hasReview: this.hasReview,
          wordSearchFocused: this.wordSearchFocused,
          onBlurWordSearch: this.onBlurWordSearch,
          onFocusWordSearch: this.onFocusWordSearch,
          showAddGermanWordTab: this.showAddGermanWordTab,
          defaultDeckId: this.defaultDeckId,
          showSpinner: this.showSpinner,
          toggleConvertCardSubmissions: this.toggleConvertCardSubmissions,
          deckIds: this.deckIds,
          cardTypeIds: this.cardTypeIds
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showAddWord", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return true;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "word", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "selectedDeckId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "cardTypeIds", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return ['b6813ff6-c5df-4dd5-b9bc-202be20bfa8c'];
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "reviewCreatedMessage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "numberCards", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "frontText", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "backText", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "wordSearchValue", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "wordSearchFocused", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "disableSubmit", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "disableSubmit"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "disableCancel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "disableCancel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypeOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypeOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userSubmission", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userSubmission"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showAddGermanWordTab", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showAddGermanWordTab"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "defaultDeckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "defaultDeckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "deckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleConvertCardSubmissions", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleConvertCardSubmissions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSubmit", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSubmit"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterSubmit", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterSubmit"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeReviewCreatedMessage", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "removeReviewCreatedMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetShowAddWord", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetShowAddWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetFrontText", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetFrontText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetBackText", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetBackText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetDeckId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetDeckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetWord", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetCardTypeId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetCardTypeId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onCreateWord", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onCreateWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onCancel", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onCancel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetWordSearchValue", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetWordSearchValue"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onBlurWordSearch", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onBlurWordSearch"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onFocusWordSearch", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onFocusWordSearch"), _class2.prototype), _class2)) || _class;
};
ReviewCreateWrapper.displayName = 'ReviewCreateWrapper';
var _default = exports["default"] = ReviewCreateWrapper;